<ng-template cellTemplate let-dataItem="dataItem">
    <div>{{dataItem | property:field | wbo_date_time:pattern}}</div>
</ng-template>
